import {
  array,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

export const getReturnReasons = {
  name: "getReturnReasons" as const,
  input: zNull(),
  output: object({ detectedFlowReasons: array(string()) }),
};

export type GetReturnReasonsOutput = zInfer<typeof getReturnReasons.output>;
